<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2775"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2779"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2789"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2787" /></clipPath></defs><g
     id="g2781"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2783"><g
         id="g2785"
         clip-path="url(#clipPath2789)"><g
           id="g2791"
           transform="translate(416.667,400.5996)"><path
             d="M 0,0 H 80.333"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2793" /></g><g
           id="g2795"
           transform="translate(15,400.5996)"><path
             d="M 0,0 H 305.267"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2797" /></g><g
           id="g2799"
           transform="translate(15,256)"><path
             d="M 0,0 H 80.333"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2801" /></g><g
           id="g2803"
           transform="translate(191.7334,256)"><path
             d="M 0,0 H 305.267"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2805" /></g><g
           id="g2807"
           transform="translate(15,111.4004)"><path
             d="M 0,0 H 224.934"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2809" /></g><g
           id="g2811"
           transform="translate(336.333,111.4004)"><path
             d="M 0,0 H 160.667"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2813" /></g><g
           id="g2815"
           transform="translate(368.4668,448.7998)"><path
             d="m 0,0 c 26.598,0 48.2,-21.602 48.2,-48.2 0,-26.598 -21.602,-48.199 -48.2,-48.199 -26.599,0 -48.2,21.601 -48.2,48.199 C -48.2,-21.602 -26.599,0 0,0 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2817" /></g><g
           id="g2819"
           transform="translate(143.5332,304.2002)"><path
             d="m 0,0 c 26.599,0 48.2,-21.602 48.2,-48.2 0,-26.599 -21.601,-48.2 -48.2,-48.2 -26.598,0 -48.2,21.601 -48.2,48.2 C -48.2,-21.602 -26.598,0 0,0 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2821" /></g><g
           id="g2823"
           transform="translate(288.1338,159.5996)"><path
             d="m 0,0 c 26.598,0 48.199,-21.602 48.199,-48.199 0,-26.599 -21.601,-48.2 -48.199,-48.2 -26.599,0 -48.2,21.601 -48.2,48.2 C -48.2,-21.602 -26.599,0 0,0 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2825" /></g></g></g></g></svg>
</template>
